// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAmn_ZCr4q8xDuubzkzW0D-Ou9r_Kqt8Eg",
    authDomain: "pdfmaken.firebaseapp.com",
    projectId: "pdfmaken",
    storageBucket: "pdfmaken.appspot.com",
    messagingSenderId: "457461467804",
    appId: "1:457461467804:web:27f0700666efa56f7c3b59",
    measurementId: "G-2BRRTGPJNS"

  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
